import { Popover, Progress, Table, Tag, Tooltip } from "antd"
import { get } from "lodash"
import React, { useEffect } from "react"
import questionIcon from "images/question.svg"
import imgMark from "images/mark_item.svg"
import "./index.less"
import Bubbles from "../Bubbles"
import { truncateText, validate } from "../../utils/functions"
import { loadTexts, sanitize } from "../../utils/i18n"
import { verifyFeatureFlag } from "../../utils/feature-flags"

const ResultByQuestion = (props) => {
  const intlresultByQuestion = loadTexts("reports_dimensions_view")
    .contentBottomDimension.resultByQuestion
  const [finalData, setFinalData] = React.useState([])
  useEffect(() => {
    const { data } = props
    const helperData = data.filter((item) => !item.engagement)
    const finalSort = helperData.sort(
        (a, b) => (Number(a.value) < Number(b.value)) ? 1 : (Number(a.value) > Number(b.value)) ? -1 : 0
    )
    setFinalData(finalSort)
  },[props.data])

  const contentVariation = (
    <div className="content-variation">
      <p>{sanitize(intlresultByQuestion.tooltipVariation.content)}</p>
      <div>
        <div className="content-variation__triangle content-variation__triangle--positive" />
        {intlresultByQuestion.tooltipVariation.variationPositive}
      </div>
      <div>
        <div className="content-variation__triangle" />
        {intlresultByQuestion.tooltipVariation.variationNegative}
      </div>
    </div>
  )

  const renderBubble = (text, record) => {
    return (
      <div
        className="bubble"
        style={
          parseFloat(record.impact) == 0
            ? { gridTemplateColumns: "auto auto auto" }
            : {}
        }>
        {parseFloat(record.impact) >= 0.5 ? (
          <Popover
            placement="right"
            content={intlresultByQuestion.columns.highImpact}>
            <img src={imgMark} />
          </Popover>
        ) : (
          <div />
        )}

        <span
          style={
            parseFloat(record.impact) == 0
              ? { marginLeft: 0, textAlign: "center", color: "#8d8a8d" }
              : {}
          }>
          {parseFloat(record.impact) == 0 ? (
            <Tooltip title={intlresultByQuestion.notSignificativeImpact}>
              <span style={{ color: "#8D8A8D" }}>-</span>
            </Tooltip>
          ) : (
            record.impact
          )}
        </span>
        {parseFloat(record.impact) != 0 ? (
          <Bubbles
            left={parseFloat(record.impact)}
            right={parseFloat(record.impact)}
          />
        ) : (
          <div />
        )}
      </div>
    )
  }

  const columns = () => {
    let baseColumns = []
    let measureWithoutSegments = false

    if (props.measureInfo.segments) {
        measureWithoutSegments = props.measureInfo.segments.length == 0
    }

    if (props.bubble && props.measureInfo.employees>20 && (props.idSegment || measureWithoutSegments)) {
        baseColumns = [
          ...baseColumns,
          {
            title: intlresultByQuestion.columns.impact,
            dataIndex: "bubbles",
            render: renderBubble,
            width: "112px",
          },
        ]
    }

    baseColumns = [
        ...baseColumns,
        {
            title: intlresultByQuestion.columns.questions,
            dataIndex: "questions",
            render: (text, record) => record.question_name,
        }
    ]

    if(verifyFeatureFlag('seg2-5') && props.measureInfo.id_scope_type == 2 && props.measureInfo.new_version >= 1 && props.idSegment == null){
      const columnSegments = {
        title: intlresultByQuestion.columns.segment,
        dataIndex: "segments",
        render: (text, record) =>{
          let segmentsText = truncateText(record.segments, 20)
          return <Tooltip placement="top" title={record.segments}>{segmentsText}</Tooltip>
        },
        width: '185px'
      }

      baseColumns = [
        ...baseColumns,
        columnSegments
      ]
    }

    baseColumns = [
      ...baseColumns,
      {
        title: intlresultByQuestion.columns.dimension,
        dataIndex: "dimension",
        render: (text, record) => record.dimension_name,
        sorter: (a, b) => a.dimension_name.localeCompare(b.dimension_name),
      },
      {
          title: intlresultByQuestion.columns.result,
          dataIndex: "metric_total_label",
          render: (text, record) =>
          record.anonymity_check.valid ? (
              <Tag color={record.color}>{record.value_visible}</Tag>
          ) : (
              "-"
          ),
          width: "100px",
          sorter: (a, b) => a.value - b.value,
      }
    ]

    if (props.measureInfo.id_survey_calculation_type === 1) {
        const topTwoBoxColumns = [
            {
                title: "1 - 2",
                dataIndex: "value_1_2",
                render: (text, record) =>
                  record.anonymity_check.valid ? (
                    <span className="value_text" style={{color: "#E37879"}}>{record.value_low_visible}</span>
                  ) : (
                    "-"
                  ),
                width: "60px",
              },
              {
                title: "3",
                dataIndex: "value_3",
                render: (text, record) =>
                  record.anonymity_check.valid ? (
                    <span className="value_text" style={{color: "#F6B673"}}>{record.value_middle_visible}</span>
                  ) : (
                    "-"
                  ),
                width: "60px",
              },
              {
                title: "4 - 5",
                dataIndex: "value_4_5",
                render: (text, record) =>
                  record.anonymity_check.valid ? (
                    <span className="value_text" style={{color: "#55C8AE"}}>{record.value_visible}</span>
                  ) : (
                    "-"
                  ),
                width: "60px",
              },
        ]
        baseColumns = [...baseColumns, ...topTwoBoxColumns]
    } else {
        const averageColumns = [
            {
              title: "1",
              dataIndex: "p1",
              render: (text, record) =>
                record.anonymity_check.valid ? (
                  <span className="value_text">
                    {get(record, "values_avg.p1", "0%")}
                  </span>
                ) : (
                  "-"
                ),
              width: "69px",
            },
            {
              title: "2",
              dataIndex: "p2",
              render: (text, record) =>
                record.anonymity_check.valid ? (
                  <span className="value_text">
                    {get(record, "values_avg.p2", "0%")}
                  </span>
                ) : (
                  "-"
                ),
              width: "69px",
            },
            {
              title: "3",
              dataIndex: "p3",
              render: (text, record) =>
                record.anonymity_check.valid ? (
                  <span className="value_text">
                    {get(record, "values_avg.p3", "0%")}
                  </span>
                ) : (
                  "-"
                ),
              width: "69px",
            },
            {
              title: "4",
              dataIndex: "p4",
              render: (text, record) =>
                record.anonymity_check.valid ? (
                  <span className="value_text">
                    {get(record, "values_avg.p4", "0%")}
                  </span>
                ) : (
                  "-"
                ),
              width: "69px",
            },
            {
              title: "5",
              dataIndex: "p5",
              render: (text, record) =>
                record.anonymity_check.valid ? (
                  <span className="value_text">
                    {get(record, "values_avg.p5", "0%")}
                  </span>
                ) : (
                  "-"
                ),
              width: "69px",
            },
          ]
          baseColumns = [...baseColumns, ...averageColumns]
    }

    if ((props.showVariation || props.showHistory) && !props.ifFirst) {
        baseColumns = [
          ...baseColumns,
          {
            title: () => (
              <span>
                {`${intlresultByQuestion.columns.previousMeasure} `}
                <Popover placement="bottomRight" content={contentVariation}>
                  <img
                    src={questionIcon}
                    alt="question"
                    style={{ marginLeft: 4, cursor: "pointer" }}
                  />
                </Popover>
              </span>
            ),
            dataIndex: "previous",
            render: (text, record) => {
              if (record.prev_value === "") {
                return "-"
              }

              if (!record.anonymity_check.valid) {
                return "-"
              }

              return (
                <span>
                  <strong>{get(record, "prev_value", "")} </strong>

                  {get(record, "variation", 0) !== 0 && (
                    <>
                      <span
                        className={`${
                          get(record, "variation", 0) > 0
                            ? "green-text"
                            : "red-text"
                        }`}>
                        {get(record, "variation_display", "")}
                      </span>
                      <div
                        className={`triangle ${
                          get(record, "variation", 0) > 0
                            ? "triangle--positive"
                            : ""
                        }`}
                      />
                    </>
                  )}
                </span>
              )
            },
            width: "130px",
          },
        ]
      }

    return baseColumns
  }

  return (
    <div style={{width: "100%", overflowX: "auto"}}>
        <Table
            bordered
            size="small"
            columns={columns()}
            rowKey={(record) => {
            if (record.id_question) {
                return record.id_question
            }
            return record.id_dimension
            }}
            dataSource={finalData}
            pagination={false}
        />
    </div>
  )
}

export default ResultByQuestion
